import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
  addCompositionPageEdit: ['stock'],
  removeCompositionPageEdit: ['stock'],
});
export const EstablishmentTypes = Types;
export default Creators;

const INITIAL_STATE = Immutable([]);

const addCompositionPageEdit = (state = INITIAL_STATE, { data }) => {
  if (state.some((element) => element.page === data.page)) {
    const newState = state.filter((element) => element.page !== data.page);
    return [...newState, { ...data }];
  } else return [...state, { ...data }];
};

const removeCompositionPageEdit = () => {
  return [];
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ADD_COMPOSITION_PAGE_EDIT]: addCompositionPageEdit,
  [Types.REMOVE_COMPOSITION_PAGE_EDIT]: removeCompositionPageEdit,
});
